import { mode } from '@chakra-ui/theme-tools';

const activeStyles = {
  top: 0,
  left: 0,
  zIndex: 2,
  position: 'absolute',
  pointerEvents: 'none',
  mx: 3.5,
  px: 1,
  my: 3.5,
  transformOrigin: 'left top',
  color: '#9FABCB',
  fontWeight: '400',
  borderRadius: '6px'
};

const activeLabelStyles = {
  fontSize: '14px',
  transform: 'scale(0.85) translateY(-28px)'
};

export const formStyles = {
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
                color: '#099BFF'
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#0F1939', '#0F1939')(props),
            })
          }
        },
        authLabel: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
                color: '#099BFF'
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#141831', '#141831')(props),
            })
          }
        },
        popup: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
                color: '#099BFF'
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#1A243E', '#1A243E')(props),
            })
          }
        },
        card: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
                color: '#099BFF'
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#151A32', '#151A32')(props),
            })
          }
        }
      }
    }
  }
};
